<template>
	<div class="container-fluid">
		<settings-toolbar title="Company Settings"></settings-toolbar>

		<invoice-settings></invoice-settings>

		<div class="row">
			<div class="col-lg-6">
				<tax-settings></tax-settings>
			</div>
			<div class="col-lg-6">
				<company-addresses></company-addresses>
			</div>
		</div>

	</div>
</template>

<script>
import SettingsToolbar from "./SettingsToolbar"
import TaxSettings from "@/components/super_components/TaxSettings"
import InvoiceSettings from "@/components/super_components/InvoiceSettings"
import CompanyAddresses from "@/components/super_components/CompanyAddresses"

export default {

	name: 'SettingsCompanySettings',
	components: {
		SettingsToolbar,
		TaxSettings,
		InvoiceSettings,
		CompanyAddresses
	}
}
</script>